export const getElement = (selector, { context = document } = {}) =>
  context.querySelector(selector)
export const getElements = (
  selector,
  { context = document, asArray = true } = {}
) => {
  const items = context.querySelectorAll(selector)

  return asArray ? Array.from(items) : items
}

export const doesStringContainAny = (str, items = []) =>
  items.some(i => str.includes(i))

export const createElement = (tag, options = {}) => {
  const el = document.createElement(tag)
  Object.values(options).forEach(([key, value]) => {
    el.setAttribute(key, value)
  })

  return el
}

export const serializerQueryParams = params =>
  Object.entries(params)
    .map(pair => pair.map(encodeURIComponent).join('='))
    .join('&')

export const styleToNumber = str => parseInt(str, 10)

export const range = amount => [...Array(amount).keys()]

export const formatMoney = (cents, format = theme.moneyFormat) => {
  let value = ''
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
  const formatString = format

  if (typeof cents === 'string') {
    cents = cents.replace('.', '')
  }

  function formatWithDelimiters (
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) {
    if (isNaN(number) || number == null) {
      return 0
    }

    number = (number / 100.0).toFixed(precision)

    const parts = number.split('.')
    const dollars = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    )
    const cents = parts[1] ? decimal + parts[1] : ''

    return dollars + cents
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2)
      break
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0)
      break
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',')
      break
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',')
      break
  }

  return formatString.replace(placeholderRegex, value)
}

export const resizeImage = ({ src, size, crop = null, scale = null } = {}) => {
  if (size == null) {
    return src
  }

  if (size === 'master') {
    return src.replace(/http(s)?:/, '')
  }

  const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i)

  if (match != null) {
    const prefix = src.split(match[0])
    const suffix = match[0]
    const scaleString = scale ? `@${scale}x` : ''
    const cropString = crop ? `_crop_${crop}` : ''

    return `${prefix[0]}_${size}${cropString}${scaleString}${suffix}`.replace(
      /http(s)?:/,
      ''
    )
  } else {
    return null
  }
}
